import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-input-base]') && !$('[data-au-search-bar]')) return;

  addEventListeners();
}

function addEventListeners() {
  inputBaseCharsCount();
  inputBaseClear();
  inputBaseTogglePassword();
  inputBasePatternValidation();
  inputBaseDatalayer();
  searchBarDatalayer();
}

// Characters count on base input
function inputBaseCharsCount() {
  $$('[data-au-input-base] [data-au-float-input-el]').forEach((input) => {
    if (!input.closest('[data-au-input-base]').querySelector('[data-au-input-base-chars]')) return;

    input.addEventListener('keyup', function () {
      const length = input.value.length;
      const maxlength = input.getAttribute('maxlength');
      if (length <= maxlength) {
        input.closest('[data-au-input-base]').querySelector('[data-au-input-base-chars]').textContent =
          input.value.length;
      }
    });
  });
}

// Remove text from input on text remover button click and hide text remover button
function inputBaseClear() {
  $$('[data-au-input-base] [data-au-float-input-clear]').forEach((textRemover) => {
    if (!textRemover.closest('[data-au-input-base]').querySelector('[data-au-input-base-chars]')) return;

    textRemover.addEventListener('click', function () {
      textRemover.closest('[data-au-input-base]').querySelector('[data-au-input-base-chars]').textContent = 0;
    });
  });
}

// Remove text from input on text remover button click and hide text remover button
function inputBaseTogglePassword() {
  $$('[data-au-input-base] [data-au-toggle-password]').forEach((togglePassword) => {
    togglePassword.addEventListener('click', function () {
      const input = togglePassword.closest('[data-au-input-password]').querySelector('[data-au-float-input-el]');
      const isInvalid = input.hasAttribute('aria-invalid', 'true');
      const item_id = isInvalid ? 'view password_ko' : 'view password';

      if (input.type === 'password') {
        input.type = 'text';
        togglePassword.querySelector('[data-au-icon]').innerText = 'visibility_off';
      } else {
        input.type = 'password';
        togglePassword.querySelector('[data-au-icon]').innerText = 'visibility';
      }

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickModulo',
        item_id,
      });
    });
  });
}

function inputBasePatternValidation() {
  $$('[data-au-input-base]').forEach((el) => {
    if (el.querySelector('[data-au-form-pattern]')) {
      const input = el.querySelector('[data-au-float-input-el]');
      const inputError = el.querySelector('[data-au-input-base-error]');
      const clear = input.closest('[data-au-float-input]').querySelector('[data-au-float-input-clear]');
      const okClass = 'au-form-help-state-texts__text--ok';
      const koClass = 'au-form-help-state-texts__text--ko';

      input.addEventListener('keyup', (e) => {
        e.target
          .closest('[data-au-input-base]')
          .querySelectorAll('[data-au-form-pattern]')
          .forEach((pat) => {
            const regex = new RegExp(pat.dataset.auFormPattern);

            if (!input.value) {
              pat.classList.remove(okClass);
              pat.classList.remove(koClass);
            } else if (regex.test(input.value)) {
              pat.classList.add(okClass);
              pat.classList.remove(koClass);
            } else {
              pat.classList.add(koClass);
              pat.classList.remove(okClass);
            }

            if (inputError) {
              if (pat.classList.contains(koClass)) {
                inputError.classList.add('au-hide');
              } else {
                inputError.classList.remove('au-hide');
              }
            }
          });
      });

      clear.addEventListener('click', (e) => {
        e.target
          .closest('[data-au-input-base]')
          .querySelectorAll('[data-au-form-pattern]')
          .forEach((pat) => {
            pat.classList.remove(okClass);
            pat.classList.remove(koClass);
          });

        input.click();
        input.focus();
        if (inputError) {
          inputError.classList.remove('au-hide');
        }
      });
    }
  });
}

function inputBaseDatalayer() {
  $$('[data-au-input-base] input, [data-au-input-base] textarea').forEach((input) => {
    const link = input.closest('[data-au-input-base]').querySelector('a');

    input.addEventListener('click', (e) => {
      const isInvalid = e.target.hasAttribute('aria-invalid', 'true');
      const label = removeAccentMarkAndUppercase(
        e.target.closest('[data-au-input-base]').querySelector('label').innerText,
      );
      const item_id = isInvalid ? `${label}_ko` : label;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickModulo',
        item_id,
      });
    });

    if (!link) return false;
    link.addEventListener('click', (e) => {
      const isInvalid = e.target.hasAttribute('aria-invalid', 'true');
      const label = removeAccentMarkAndUppercase(
        e.target.closest('[data-au-input-base]').querySelector('label').innerText,
      );
      const linkText = removeAccentMarkAndUppercase(e.target.querySelector(':not([data-au-icon])').innerText);
      const item_id = isInvalid ? `${label}_${linkText}_ko` : `${label}_${linkText}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id,
      });
    });
  });
}

function searchBarDatalayer() {
  $$('[data-au-search-bar] input').forEach((input) => {
    input.addEventListener('click', (e) => {
      const isInvalid = e.target.hasAttribute('aria-invalid', 'true');
      const label = removeAccentMarkAndUppercase(
        e.target.closest('[data-au-search-bar]').querySelector('label').innerText,
      );
      const item_id = isInvalid ? `${label}_ko` : label;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickModulo',
        item_id,
      });
    });
  });
}

export default { init };
